/**
 * Client for /api/v1/realtors/me/digest, the morning follow-up email's
 * settings. Failures throw, for React Query's error state.
 */

import { apiClient } from "@/lib/api-client";

export interface DigestSettings {
	enabled: boolean;
	/** Where the email goes, or null when the account has no address. */
	address: string | null;
	addressSource: "account" | "google" | null;
	/** The server can link a Google account to provide an address. */
	googleLinkAvailable: boolean;
}

const DIGEST_PATH = "/api/v1/realtors/me/digest";

export async function getDigestSettings(): Promise<DigestSettings> {
	const response = await apiClient.get<{ data: { settings: DigestSettings } }>(
		DIGEST_PATH,
	);
	return response.data.data.settings;
}

export async function updateDigestSettings(
	enabled: boolean,
): Promise<DigestSettings> {
	const response = await apiClient.patch<{
		data: { settings: DigestSettings };
	}>(DIGEST_PATH, { enabled });
	return response.data.data.settings;
}
